import React from 'react';
import Layout from '../../components/layout';
import IntroductionComponent from '../../components/facilitators/introduction';

const headerText = 'FACILITATORS';

const Introduction = () => {
  return (
    <Layout headerText={headerText} heroBg="grass">
      <IntroductionComponent />
    </Layout>
  );
};

export default Introduction;
